import React, { useEffect, useState } from "react";
import { PaginationControl } from "react-bootstrap-pagination-control";
import axios from "axios";
import Swal from "sweetalert2";
import SideBar from "../../SideBar";
import HeaderName from "../../HeaderName";
import Spinner from "react-bootstrap/Spinner";
import { ExcelExport } from '@progress/kendo-react-excel-export'
import { ExcelExportColumn } from '@progress/kendo-react-excel-export'
import { useSelector } from "react-redux";
// const uri = hee

export default function StockList() {
  const token = localStorage.getItem("token");
  const url = process.env.REACT_APP_APP_URL;
  // const url = "http://192.168.1.15:4000/api/";
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  const [metaData, setMetaData] = useState()
  const _export = React.useRef(null);
  const excelExport = () => {
    if (_export.current !== null) {
      console.log(_export.current.props.data);
      _export.current.props.data.map(function (element, index) {
        element.date = element.date.split("T")[0];
        element.code = element.relatedTreatmentSelection?.code || "-"
        element.name =
          element.relatedMedicineItems?.medicineItemName

        element.branch = element.createdBy?.branchName
        element.qty = element.currentQty - element.finalQty
      });
      _export.current.save();
    }
  };

  const scroll = {
    height: "550px",
    overflowY: "scroll",
  };
  const [dataCount, setDataCount] = useState("");
  const [loading, setLoading] = useState(false);
  const [stockList, setStockList] = useState([]);
  // console.log(stockList.filter(el => el.actualQty !== 0), 's')
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [itemList, setItemList] = useState([]);
  const [items, setItems] = useState([]);
  const [urls, setUrls] = useState("");
  const [show, setShow] = useState(true);
  const [branchLists, setBranchLists] = useState([]);
  const [showBranchFilter, setShowBranchFilter] = useState(false);
  const [showOri, setShowOri] = useState(true);
  const [showExport, setShowExport] = useState(false);
  const [branchID, setBranchID] = useState('')
  const [types, setTypes] = useState('')
  const [showLoad, setShowLoad] = useState(false)
  const [page, setPage] = useState(1);
  const [pages, setPages] = React.useState("");

  const [rowsPerPage, setRowsPerPage] = React.useState(20);
  // const paginationItems = React.useMemo(() => {
  //   const start = (page - 1) * rowsPerPage;
  //   const end = start + rowsPerPage;
  //   return stockList.slice(start, end);
  // }, [page, stockList]);

  const finalFilter = (event) => {
    setShowLoad(true)
    let data = {
      id: event.target.value,
    };
    api
      .get("logs/filter", { params: data })
      .then((response) => {
        // setTodayList([])
        setMetaData(response.data.meta)
        setStockList(response.data.data.filter(el => el.actualQty !== 0 && el.actualQty && el.date >= startDate && (el.date = endDate || el.date < endDate)));
        setShowLoad(false)

      })
      .catch((error) => {
        Swal.fire({
          title: "404",
          text: error.response.data.message,
          icon: "warning",
          confirmButtonText: "CANCEL",
        });
      });
    // const filteredArray = stockList.filter(obj => [obj.relatedProcedureItems?._id, obj.relatedAccessoryItems?._id, obj.relatedMachine?._id].includes(event.target.value));
    // console.log(filteredArray,'filterdarray')
    // setStockList(filteredArray)
  };

  const handleItems = (event) => {
    if (urls === "false") {
      setShow(false);
      let data = {
        id: event,
      };
      api
        .get("logs/filter", { params: data })
        .then((response) => {
          // setTodayList([])
          setStockList(response.data.data);
          // console.log(response.data, "data");
        })
        .catch((error) => {
          Swal.fire({
            title: "404",
            text: error.response.data.message,
            icon: "warning",
            confirmButtonText: "CANCEL",
          });
        });
    } else {
      setShow(true);
      api
        .get(urls + "/" + event)
        .then((response) => {
          // setTodayList([])
          setItems(response.data.data);
        })
        .catch((error) => {
          Swal.fire({
            title: "Error",
            text: error.response.data.message,
            icon: "error",
            confirmButtonText: "CANCEL",
          });
        });
    }
  };

  const handleCategory = (event) => {
    switch (event) {
      case "Machine": {
        handleMachine();
        setUrls("false");
        setShow(true);
        break;
      }
      case "Procedure Medicine": {
        handleProcedureMedicine();
        setUrls("procedure-items");
        break;
      }
      case "Procedure Accessory": {
        handleProcedureAccessory();
        setUrls("accessory-items");
        break;
      }
      case "Medicine": {
        handleMedicine();
        setUrls("medicine-items");
        break;
      }
      default:
        return event;
    }
  };
  const handleBranch = (id) => {
    // console.log(id, "name");
    setBranchID(id)
    if (id === "HO") {
      window.location.reload()
    }
    // if (id === "HO") {
    //   setShowBranchFilter(true);
    //   setShowOri(false);
    // } else {
    //   setStockList(stockList.filter((el) => el?.relatedBranch?._id === id));
    //   // console.log(stockList.filter((el) => el?.relatedBranch?._id === id), 'heee')
    //   setDataCount(
    //     stockList.filter((el) => el?.relatedBranch?._id === id).length
    //   );
    //   setPages(
    //     stockList.filter((el) => el?.relatedBranch?._id === id).length %
    //       rowsPerPage ===
    //       0
    //       ? stockList.filter((el) => el?.relatedBranch?._id === id).length /
    //       rowsPerPage
    //       : Math.floor(
    //         stockList.filter((el) => el?.relatedBranch?._id === id).length /
    //         rowsPerPage
    //       ) + 1
    //   );
    //   // console.log(
    //   //   stockList.filter((el) => el?.relatedBranch?._id === id),
    //   //   "filter"
    //   // );
    //   setShowBranchFilter(true);
    //   setShowOri(false);
    // }
  };

  const handleMachine = (event) => {
    api
      .get("fixed-assets")
      .then((response) => {
        // setTodayList([])
        setItemList(response.data.list);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error.response.data.message,
          icon: "error",
          confirmButtonText: "CANCEL",
        });
      });
  };
  const handleMedicine = (event) => {
    api
      .get("medicine-lists")
      .then((response) => {
        // setTodayList([])
        setItemList(response.data.list);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error.response.data.message,
          icon: "error",
          confirmButtonText: "CANCEL",
        });
      });
  };
  const handleProcedureMedicine = (event) => {
    api
      .get("procedure-medicines")
      .then((response) => {
        // setTodayList([])
        setItemList(response.data.list);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error.response.data.message,
          icon: "error",
          confirmButtonText: "CANCEL",
        });
      });
  };
  const handleProcedureAccessory = (event) => {
    api
      .get("procedure-accessories")
      .then((response) => {
        // setTodayList([])
        setItemList(response.data.list);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error.response.data.message,
          icon: "error",
          confirmButtonText: "CANCEL",
        });
      });
  };

  // const filter = (event) => {
  //   setLoading(true);
  //   // console.log(types, 'type')
  //   // console.log(branchID, 'bra id')
  //   const nDate = new Date(endDate);
  //   const finalDate = nDate.setDate(nDate.getDate() + 1);
  //   const date = new Date(finalDate);

  //   // Format to YYYY-MM-DD
  //   const formattedDate = date.toISOString().split('T')[0];
  //   let data = {
  //     start: startDate,
  //     end: formattedDate,

  //     type: types,
  //     limit: rowsPerPage,
  //     page: page
  //   };
  //   if (branchID !== 'HO') {
  //     data.branch = branchID
  //   }
  //   // getStockLogList(data)
  //   // api
  //   //   .get("logs/filter", { params: data })
  //   //   .then((response) => {
  //   //     // setTodayList([])
  //   //     setMetaData(response.data.meta)

  //   //     // console.log(response.data.data, 'log file')
  //   //     setStockList(response.data.data);

  //   //     setLoading(false);
  //   //     setShowOri(false)
  //   //     setShowBranchFilter(true)
  //   //     setShowExport(true)




  //   //   })
  //   //   .catch((error) => {
  //   //     Swal.fire({
  //   //       title: "Error",
  //   //       text: error.response.data.message,
  //   //       icon: "error",
  //   //       confirmButtonText: "CANCEL",
  //   //     });
  //   //     setLoading(false);
  //   //   });
  // };
  const getStockLogList = async () => {
    // if (val === 'filter') {
    //   setLoading(true);
    // }

    // console.log(types, 'type')
    // console.log(branchID, 'bra id')
    const nDate = endDate && new Date(endDate);
    const finalDate = endDate && nDate.setDate(nDate.getDate() + 1);
    const date = endDate && new Date(finalDate);

    // Format to YYYY-MM-DD
    const formattedDate = endDate && date.toISOString().split('T')[0];
    let data = {
      start: startDate,
      end: formattedDate,

      type: types,
      limit: rowsPerPage,
      page: page
    };
    if (branchID !== 'HO') {
      data.branch = branchID
    }
    api
      .get("logs/filter", { params: data })
      .then((response) => {
        console.log(response.data.data, "log list");
        setMetaData(response.data.meta)
        setStockList(response.data.data);
        setLoading(false);
        setShowOri(false)
        setShowBranchFilter(true)
        setShowExport(true)

      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: "No Record",
          icon: "error",
          confirmButtonText: "CANCEL",
        });
      });
  };
  useEffect(() => {


    const getBranches = async () => {
      try {
        const res = await api.get("branches");
        setBranchLists(res.data.list);
      } catch (err) {
        alert(err.message);
      }
    };
    getBranches();

    getStockLogList();
  }, [page, types]);

  return (
    <div classNameName='App'>
      {/* <!-- end preloader --> */}
      {/* @include('sweet::alert') */}

      <div className='wrapper'>
        {/* <!-- Navbar --> */}
        <HeaderName />

        {/* <!-- /.navbar --> */}

        {/* <!-- Main Sidebar Container --> */}
        <SideBar />

        {/* <!-- Content Wrapper. Contains page content --> */}
        <div className='content-wrapper'>
          {/* <!-- Content Header (Page header) --> */}
          <div className='content-header'>
            <div className='container-fluid'>
              <div className='row mb-2'>
                <div className='col-sm-12'>
                  <ol className='breadcrumb'>
                    <li className='breadcrumb-item active fs-5 text-bold'>
                      Log List
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12'>
              <div className='row ml-2'>
                <div className='form-group col-md-2'>
                  <label>From</label>
                  <input
                    type='date'
                    name='from'
                    id='from'
                    className='form-control'
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                </div>
                <div className='form-group col-md-2'>
                  <label>To</label>
                  <input
                    type='date'
                    name='to'
                    id='to'
                    className='form-control'
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </div>

                <div
                  className=' form-group col-md-2'
                  style={{ marginTop: "2.4em" }}
                >
                  <select
                    class='custom-select border-info'
                    onChange={(e) =>
                      handleBranch(e.target.value)
                    }
                  >
                    <option hidden>Choose Branch</option>
                    <option value='HO'>All</option>
                    {branchLists.map((option) => (
                      <option value={option._id}>{option.name}</option>
                    ))}
                  </select>
                </div>

                <div
                  className=' form-group col-md-2'
                  style={{ marginTop: "2.4em" }}
                >
                  <select
                    class='custom-select border-info'
                    onChange={(e) =>
                      setTypes(e.target.value)
                    }
                  >
                    <option hidden>Choose Types</option>
                    <option value='Usage'>Usage</option>
                    <option value='Stock Transfer'>Stock Transfer</option>
                    <option value='Request Recieved'>Request Recieved</option>
                    <option value='Stock Update'>HO Stock Update</option>
                    <option value='Medicine Sale'>Voucher Items</option>

                  </select>
                </div>
                {/* <div className='col-md-1'>
                  {loading === false ? (
                    <button
                      className='btn btn-sm btn-primary form-control'
                      style={{ marginTop: "33px" }}
                      onClick={() => getStockLogList("filter")}
                    >
                      Filter
                    </button>
                  ) : (
                    <button
                      className='btn btn-sm btn-primary form-control'
                      style={{ marginTop: "33px" }}
                      disabled
                    >
                      <Spinner
                        as='span'
                        animation='grow'
                        size='sm'
                        role='status'
                        aria-hidden='true'
                      />
                      Loading...
                    </button>
                  )}
                </div> */}

                {showExport && (
                  <div className=' form-group col-md-1'
                    style={{ marginTop: "2.4em" }}><button className='btn btn-md btn-success' onClick={excelExport}>Export</button></div>
                )}

              </div>
            </div>
          </div>
          {/* <!-- Main content --> */}
          <div className='row'>
            <div className='col-12'>
              <div className='card'>
                <div className='card-header'>
                  {/* {showExport && (
                    <div className='row '>
                      <div className='form-group col-md-2 mt-2'>
                        <select
                          class='custom-select border-info'
                          onChange={(e) => {
                            handleCategory(e.target.value);
                          }}
                        >
                          <option hidden>Choose Category</option>
                          <option value='Medicine'>Medicine</option>
                          <option value='Procedure Medicine'>
                            Procedure Medicine
                          </option>
                          <option value='Procedure Accessory'>
                            Procedure Accessory
                          </option>
                          <option value='Machine'>Machine</option>
                        </select>
                      </div>

                      <div className='form-group col-md-2 mt-2'>
                        <select
                          class='custom-select border-info'
                          onChange={(e) => handleItems(e.target.value)}
                        >
                          <option hidden>Choose Item List</option>
                          {itemList.map((element, index) => (
                            <option value={element._id}>{element.name}</option>
                          ))}
                        </select>
                      </div>
                      {show ? (
                        <div className='form-group col-md-2 mt-2'>
                          <select
                            class='custom-select border-info'
                            onChange={(e) => finalFilter(e)}
                          >
                            <option hidden>Choose Items</option>
                            {items.map((element, index) => (
                              <option value={element._id}>
                                {element.procedureItemName
                                  ? element.procedureItemName
                                  : element.accessoryItemName ? element.accessoryItemName : element.medicineItemName}
                              </option>
                            ))}
                          </select>
                        </div>
                      ) : (
                        ""
                      )}
                      <div className='form-group col-md-2 mt-3'>
                        {(showLoad) && <span className='text-lg'>Loading ...</span>}
                      </div>
                    </div>
                  )} */}

                </div>
                {/* Export data in Excel */}
                <ExcelExport data={stockList} ref={_export} fileName="Log List">
                  <ExcelExportColumn
                    field=""
                    title="No"
                    locked={true}
                    width={30}
                  />
                  <ExcelExportColumn
                    field="code"
                    title="Voucher Code"
                    headerCellOptions={{
                      textAlign: "center",
                    }}
                    cellOptions={{

                      textAlign: "center",
                    }}
                    width={200}
                  />

                  <ExcelExportColumn
                    field="date"
                    title="Date"
                    headerCellOptions={{
                      textAlign: "center",
                    }}
                    cellOptions={{

                      textAlign: "center",
                    }}
                    width={250}
                  />

                  <ExcelExportColumn
                    field="name"
                    title="Items Name"
                    headerCellOptions={{
                      textAlign: "center",
                    }}
                    cellOptions={{

                      textAlign: "center",
                    }}
                    width={350}
                  />

                  <ExcelExportColumn
                    field="type"
                    title="Type"
                    width={150}
                    headerCellOptions={{
                      textAlign: "center",
                    }}
                    cellOptions={{

                      textAlign: "center",
                    }}
                  />
                  <ExcelExportColumn
                    field="relatedTreatmentSelection.relatedTreatment.treatmentCode"
                    title="Treatment Code"
                    width={150}
                    headerCellOptions={{
                      textAlign: "center",
                    }}
                    cellOptions={{

                      textAlign: "center",
                    }}
                  />
                  <ExcelExportColumn
                    field="relatedTreatmentSelection.relatedTreatment.name"
                    title="Treatment Name"
                    width={550}

                  />
                  <ExcelExportColumn
                    field="branch"
                    title="Branch"
                    width={150}
                    headerCellOptions={{
                      textAlign: "center",
                    }}
                    cellOptions={{

                      textAlign: "center",
                    }}
                  />
                  <ExcelExportColumn
                    field="currentQty"
                    title="Current Qty"
                    width={150}
                    headerCellOptions={{
                      textAlign: "center",
                    }}
                    cellOptions={{

                      textAlign: "center",
                    }}
                  />
                  <ExcelExportColumn
                    field="qty"
                    title="Actual Qty"
                    width={150}
                    headerCellOptions={{
                      textAlign: "center",
                    }}
                    cellOptions={{

                      textAlign: "center",
                    }}
                  />
                  <ExcelExportColumn
                    field="finalQty"
                    title="Final Qty"
                    width={150}
                    headerCellOptions={{
                      textAlign: "center",
                    }}
                    cellOptions={{

                      textAlign: "center",
                    }}
                  />
                </ExcelExport>
                {/* Export Data in Excel end */}
                <div className='card-body' style={scroll}>
                  <table id='example1' className='table'>
                    <thead className='sticky-top bg-light'>
                      <tr>
                        <th>No</th>
                        <th>Vou Code</th>
                        <th>Date</th>
                        <th>Item Name</th>
                        <th>Type</th>
                        {/* <th>Treatment Code</th>
                        <th>Related Treatment</th> */}
                        <th>Created By</th>
                        <th>Branch For</th>
                        {stockList[0]?.type === 'Stock Transfer' ? (
                          <>
                            <th>Transfer Qty</th>

                          </>
                        ) : (
                          <>
                            <th>From Qty</th>
                            <th>Changed QTY</th>
                            <th>To QTY</th></>
                        )}

                      </tr>
                    </thead>
                    <>
                      {showOri &&
                        (stockList ? (
                          stockList
                            .slice(0)
                            .reverse()
                            .map((e, i) => (
                              <tbody key={e._id}>
                                <tr>
                                  <td>{(page - 1) * rowsPerPage + i + 1}</td>
                                  <td>
                                    {e.relatedTreatmentSelection
                                      ? e.relatedTreatmentSelection.code
                                      : "-"}
                                  </td>
                                  <td>{e.date ? e.date.split("T")[0] : ""}</td>
                                  <td>
                                    {e.relatedProcedureItems[0]
                                      ?.procedureItemName ||
                                      e.relatedAccessoryItems[0]
                                        ?.accessoryItemName ||
                                      e.relatedMachine[0]?.name ||
                                      e.relatedMedicineItems[0]?.medicineItemName || e.relatedGeneralItems[0]?.generalItemName || e?.relatedStock?.relatedMedicineItems[0]?.medicineItemName || e?.relatedStock?.relatedProcedureItems[0]?.procedureItemName || e?.relatedStock?.relatedAccessoryItems[0]?.accessoryItemName}
                                  </td>
                                  <td>{e?.type}</td>


                                  <td>
                                    {e.relatedBranch ? e.relatedBranch.branchName : ""}
                                  </td>
                                  {e.type === "Stock Transfer" ? (
                                    <>
                                      <td className='col-3'>{e.currentQty ? Math.round(e.currentQty) : "-"}</td>
                                    </>


                                  ) : (
                                    <>
                                      <td>{e.currentQty ? Math.round(e.currentQty) : "-"}</td>
                                      <td>{e.actualQty ? e.actualQty : Math.round(e.currentQty - e.finalQty)}</td>
                                      <td>{e.finalQty ? Math.round(e.finalQty) : "-"}</td>
                                    </>

                                  )}

                                  {/* <td className='text-center'>
                              <button class='btn btn-primary btn-sm'>
                                Related
                              </button>
                            </td> */}
                                </tr>

                                <tr
                                  className='bg-gradient-light'
                                  id={"toggle" + e._id}
                                  hidden
                                >
                                  <td colspan='12'>
                                    <div>
                                      <div class='row'>
                                        <div class='col-md-2'>
                                          <label
                                            style={{ fontSize: "15px" }}
                                            class='text-dark'
                                          >
                                            No
                                          </label>
                                        </div>
                                        <div class='col-md-3'>
                                          <label
                                            style={{ fontSize: "15px" }}
                                            class='text-dark'
                                          >
                                            Account
                                          </label>
                                        </div>
                                        <div class='col-md-2'>
                                          <label
                                            style={{ fontSize: "15px" }}
                                            class='text-dark'
                                          >
                                            Type
                                          </label>
                                        </div>
                                        <div class='col-md-2'>
                                          <label
                                            style={{ fontSize: "15px" }}
                                            class='text-dark'
                                          >
                                            Date
                                          </label>
                                        </div>
                                        <div class='col-md-2'>
                                          <label
                                            style={{ fontSize: "15px" }}
                                            class='text-dark'
                                          >
                                            Amount
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            ))
                        ) : (
                          <div>Please use date filter</div>
                        ))}

                      {showBranchFilter &&
                        stockList
                          .slice(0)
                          .reverse()
                          .map((e, i) => (
                            <tbody key={e._id}>
                              <tr>
                                <td>{(page - 1) * rowsPerPage + i + 1}</td>
                                <td>
                                  {e.relatedTreatmentSelection[0]
                                    ? e.relatedTreatmentSelection[0].code
                                    : "-"}
                                </td>
                                <td>{e.date ? e.date.split("T")[0] : ""}</td>
                                <td>
                                  {
                                    e.relatedMedicineItems?.medicineItemName || "-"}
                                </td>
                                <td>{e?.type === "Medicine Sale" && "Voucher Items"}</td>

                                <td>
                                  {e.createdBy
                                    ? e.createdBy?.givenName
                                    : "-"}
                                </td>
                                <td>
                                  {e.relatedBranch ? e.relatedBranch.name : "-"}
                                </td>
                                {e.type === "Stock Transfer" ? (
                                  <>
                                    <td className='col-3'>{e.currentQty ? Math.round(e.currentQty) : "-"}</td>
                                  </>


                                ) : (
                                  <>
                                    <td>{e.currentQty ? Math.round(e.currentQty) : "-"}</td>
                                    <td>{Math.round(e.currentQty - e.finalQty)}</td>
                                    <td>{e.finalQty ? Math.round(e.finalQty) : "-"}</td>
                                  </>

                                )}
                                {/* <td className='text-center'>
                              <button class='btn btn-primary btn-sm'>
                                Related
                              </button>
                            </td> */}
                              </tr>

                              <tr
                                className='bg-gradient-light'
                                id={"toggle" + e._id}
                                hidden
                              >
                                <td colspan='12'>
                                  <div>
                                    <div class='row'>
                                      <div class='col-md-2'>
                                        <label
                                          style={{ fontSize: "15px" }}
                                          class='text-dark'
                                        >
                                          No
                                        </label>
                                      </div>
                                      <div class='col-md-3'>
                                        <label
                                          style={{ fontSize: "15px" }}
                                          class='text-dark'
                                        >
                                          Account
                                        </label>
                                      </div>
                                      <div class='col-md-2'>
                                        <label
                                          style={{ fontSize: "15px" }}
                                          class='text-dark'
                                        >
                                          Type
                                        </label>
                                      </div>
                                      <div class='col-md-2'>
                                        <label
                                          style={{ fontSize: "15px" }}
                                          class='text-dark'
                                        >
                                          Date
                                        </label>
                                      </div>
                                      <div class='col-md-2'>
                                        <label
                                          style={{ fontSize: "15px" }}
                                          class='text-dark'
                                        >
                                          Amount
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          ))}
                    </>
                  </table>
                </div>
                <div className='mt-4'>
                  <PaginationControl
                    page={page}
                    between={4}
                    total={metaData?.total_count}
                    limit={rowsPerPage}
                    changePage={(page) => {
                      setPage(page);
                    }}
                    ellipsis={1}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* <MedicineSaleDialog
            open={open}
            close={() => setOpen(false)}
            setOpen={setOpen}
            grand={grand}
          /> */}
        </div>

        {/* <!-- /.content-wrapper --> */}
        <footer className='main-footer'>
          <strong>
            Copyright &copy; 2017-2020{" "}
            <a href='http://www.kwintechnologies.com'>K-win Technology</a>.
          </strong>
          All rights reserved.
        </footer>

        {/* <!-- Control Sidebar --> */}
        <aside className='control-sidebar control-sidebar-dark'>
          {/* <!-- Control sidebar content goes here --> */}
        </aside>
        {/* <!-- /.control-sidebar --> */}
      </div>
      {/* <!-- ./wrapper --> */}
    </div>
  );
}
